import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
const API_URL = import.meta.env.VITE_API_URL;

function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${API_URL}/api/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username, password }),
            });
            const data = await response.json();
            if (response.ok) {
                login(data.access_token);
                navigate("/adminPanel");
            } else {
                setErrorMessage(data.message || "Erro ao fazer login.");
            }
        } catch{
            setErrorMessage("Erro ao conectar ao servidor.");
        }
    };

    return (
        /* Mudamos bg-gray-100 para bg-background */
        <div className="min-h-screen flex items-center justify-center bg-background transition-colors duration-300">
            {/* Mudamos bg-white para bg-surface com nossas classes padronizadas */}
            <div className="bg-surface p-8 rounded-2xl shadow-card border border-border-light w-full max-w-md transition-colors duration-300">
                <h1 className="text-3xl font-bold mb-6 text-center text-text-primary">Login</h1>
                
                {errorMessage && (
                    <p className="text-red-500 text-sm mb-4 text-center">{errorMessage}</p>
                )}
                
                <form onSubmit={handleLogin} className="space-y-5">
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Usuário:</label>
                        {/* Usando nossa classe global input-field */}
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="input-field"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Senha:</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="input-field"
                            required
                        />
                    </div>
                    {/* Usando nossa classe global btn-primary */}
                    <button type="submit" className="btn-primary w-full mt-2">
                        Entrar
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Login;